<template>
  <transition name="slide">
    <div :class="['rounded-xl border p-4', variantClasses[variant].container]">
      <div class="flex items-start gap-3">
        <span :class="`mt-0.5 pi ${icons[variant]} text-white`">
        </span>

        <div>
          <h4
            class="mb-1 text-sm font-semibold text-gray-800 dark:text-white/90 "
          >
            {{ title }}
          </h4>

          <p class="text-sm text-gray-500 dark:text-gray-400">{{ message }}</p>

          <router-link
            v-if="showLink"
            :to="linkHref"
            class="inline-block mt-3 text-sm font-medium text-gray-500 underline dark:text-gray-400"
          >
            {{ linkText }}
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
// import {
//   SuccessIcon, ErrorIcon, WarningIcon, InfoCircleIcon,
// } from '@/icons';
import { computed, withDefaults, defineProps } from 'vue';

interface AlertProps {
  variant: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  showLink?: boolean;
  linkHref?: string;
  linkText?: string;
}

const props = withDefaults(defineProps<AlertProps>(), {
  showLink: false,
  linkHref: '#',
  linkText: 'Learn more',
});

const variantClasses = {
  success: {
    container:
      'border-green-500/30 bg-green-500/30',
    icon: 'text-success-500',
  },
  error: {
    container:
      'border-error-500/30 bg-error-500/15',
    icon: 'text-error-500',
  },
  warning: {
    container:
      'border-warning-500/30 bg-warning-500/15',
    icon: 'text-warning-500',
  },
  info: {
    container:
      'border-blue-light-500/30 bg-blue-light-500/15',
    icon: 'text-blue-light-500',
  },
};

const icons = {
  success: 'pi-check',
  error: 'pi-exclamation-triangle',
  warning: 'pi-exclamation-circle',
  info: 'pi-info-circle',
};
</script>
